import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/sv';
import "react-day-picker/lib/style.css";
import _ from 'underscore';

import './style.scss'
import constants from '../util/constants';
const { API_BASE_URL } = constants;

class Banner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hiddenByUser: false,
            bannerActive: 0,
            headerWrapperHeight: 31
        }

        this.getBannerSettings = this.getBannerSettings.bind(this)
        this.handleCloseBanner = this.handleCloseBanner.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.shouldBannerShow = this.shouldBannerShow.bind(this)
        this.getHeaderWrapperHeight = this.getHeaderWrapperHeight.bind(this)
    }

    async componentDidMount() {
        await this.getBannerSettings()
        this.getHeaderWrapperHeight()

        let hiddenBanner = sessionStorage.getItem('banner-hide')
        hiddenBanner && this.setState({ hiddenByUser: hiddenBanner == 'true' })

        window.addEventListener("resize", this.handleResize)

        // Reresh banner settings every x seconds
        const bannerRefreshSeconds = 180
        const self = this // Pass reference to this and pass to async function
        setInterval(this.getBannerRefreshSettings, bannerRefreshSeconds * 1000, self)
    }

    async getBannerRefreshSettings(self) {
        // Get current settings before fetching new version
        let previousBannerState = {
            bannerActive: self.state.bannerActive,
            bannerText: self.state.bannerText,
            bannerStartDateTime: self.state.bannerStartDateTime,
            bannerEndDateTime: self.state.bannerEndDateTime
        }
        let previousBannerStateString = JSON.stringify(previousBannerState)

        await self.getBannerSettings()

        // Fetch new version of banner settings to compare with previous version
        let newBannerState = {
            bannerActive: self.state.bannerActive,
            bannerText: self.state.bannerText,
            bannerStartDateTime: self.state.bannerStartDateTime,
            bannerEndDateTime: self.state.bannerEndDateTime
        }
        let newBannerStateString = JSON.stringify(newBannerState)

        // If previous and new version is different, reset banner to original state
        if (self.compareTwoJsonStrings(previousBannerStateString, newBannerStateString) == false) {
            self.setState({ hiddenByUser: false })
            sessionStorage.setItem('banner-hide', false)
        }
    }

    compareTwoJsonStrings(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    async getBannerSettings() {
        const self = this;
        const getBannerSettings = 'Portal/GetBannerSettings';

        await axios.get(API_BASE_URL + getBannerSettings)
            .then(res => {
                if (res.data) 
                    self.setState({
                        bannerActive: res.data.BannerActive,
                        bannerText: res.data.BannerText,
                        bannerStartDateTime: res.data.BannerStartDateTime,
                        bannerEndDateTime: res.data.BannerEndDateTime
                    })
            })
            .catch(err => {
                console.error(err)
            });
    }

    handleCloseBanner() {
        this.setState({ hiddenByUser: true })
        sessionStorage.setItem('banner-hide', true)
    }

    handleResize() {
        const newHeaderWrapperHeight = this.getHeaderWrapperHeight()
        const { headerWrapperHeight } = this.state

        if (newHeaderWrapperHeight != headerWrapperHeight)
            this.setState({ headerWrapperHeight: newHeaderWrapperHeight })
    }

    shouldBannerShow() {
        const { hiddenByUser, bannerActive, bannerText, bannerStartDateTime, bannerEndDateTime } = this.state
        const today = moment()

        if (hiddenByUser) return false
        if (bannerActive == false) return false
        if (bannerText == "") return false

        if (today.diff(bannerStartDateTime) < 0) return false // Today is BEFORE startdate
        if (today.diff(bannerEndDateTime) > 0) return false // Today is AFTER endDate

        return true
    }

    // Since the header is very unpredictable - use this ref to determine position top
    getHeaderWrapperHeight() {
        return this.props.headerRef.current?.node?.parentElement.parentElement.clientHeight || 31
    }

    render() {
        let { bannerText, headerWrapperHeight } = this.state
        let showBanner = this.shouldBannerShow();
        return (
            <div className={showBanner ? "np-banner np-banner-show" : "np-banner"} style={{ top: `${headerWrapperHeight}px` }}>
                <span></span>
                <h3>{bannerText}</h3>
                <button className="np-banner-close" onClick={this.handleCloseBanner}><FontAwesomeIcon icon={faTimes} /></button>
            </div>
        )
    }
}

export default Banner